<div class="m-1">
  <div class="card p-1 ">
    <h4>{{textDisplay}}</h4>
    <div class="split-container">
      <div class="left-panel" [ngStyle]="{ width: leftWidth + 'px' }">
        <form class="p-1 ">
          <div id="createQuestionFormValidationErrors" tabindex="-1" role="alert"
            class="d-flex justify-content-center mb-3 text-danger" *ngIf="modelError">
            <p class="mb-0 text-center">{{modelError}}</p>
          </div>

          <div class="m-2">
            <label class="switch">
              <input type="checkbox" (click)="easyModeClicked(1)" [checked]="questionAdvanceMode"
                [disabled]="question.disabled || useQuestionBank">
              <span class="slider round"></span>
            </label>
            <span class="font-weight-bold text-capitalize ml-1"> Advanced Mode</span>
          </div>

          <div class="row">
            <div class="d-flex justify-content-between align-items-center w-100 mb-2">
              <label class="form-label mb-0">Question Editor</label>
              <button *ngIf="question.questionBankQuestionID > 0 && useQuestionBank" class="btn btn-sm btn-warning"
                (click)="replaceQuestion()" title="Replace this question with a new one from the Question Bank"
                [disabled]="question.disabled || isPsychometricTestBank">
                Replace Question
              </button>
            </div>
            <app-quill-editor *ngIf="exam && exam.id && questionAdvanceMode" [(ngModel)]="question.questionHtml"
              [ngModelOptions]="{ standalone: true }" [height]="'200px'" [placeholder]="'Type your text here...'"
              [readonly]="useQuestionBank || question.disabled" [disabled]="question.disabled || useQuestionBank">
            </app-quill-editor>
          </div>
          <textarea class="form-control w-100 question-textarea" rows="2" [(ngModel)]="question.questionHtml"
            [ngModelOptions]="{ standalone: true }" *ngIf="!questionAdvanceMode"
            [readonly]="useQuestionBank || question.disabled"></textarea>
          <hr>

          <ng-container
            *ngIf="question.questionType!='SAQ' && question.questionType!='Essay' && (exam.examinationType == 'Multiple-Choice' || exam.examinationType == '' || exam.examinationType == 'Not Set')">

            <div class="m-2 d-flex align-items-center flex-wrap">
              <div class="d-flex align-items-center me-4">
                <label class="switch mb-0">
                  <input type="checkbox" (click)="easyModeClicked(2)" [checked]="optionAdvanceMode"
                    [disabled]="question.disabled || useQuestionBank">
                  <span class="slider round"></span>
                </label>
                <span class="font-weight-bold text-capitalize ml-1"> Advanced Mode</span>
              </div>
              <div class="d-flex align-items-center">
                <label class="switch mb-0">
                  <input type="checkbox" (click)="toggleRankedMultipleChoiceSwitch()"
                    [checked]="question.rankedMultipleChoice"
                    [disabled]="useQuestionBank || question.disabled">
                  <span class="slider round"></span>
                </label>
                <span class="font-weight-bold text-capitalize ml-1"> Ranked MCQ</span>
              </div>
            </div>
            <div class="row row-cols-2 mt-1" *ngIf="question.questionType!='SAQ' && question.questionType!='Essay'">
              <div class="col mt-1" *ngFor="let option of question.options;  let i = index">
                <div class="d-flex align-items-center flex-wrap gap-2 ml-1 pe-1">
                  <div class="form-check mb-0 d-flex align-items-center gap-2 flex-shrink-0 mcq-option-answer-check">
                    <label class="form-check-label mb-0 text-nowrap" [attr.for]="'mcq-option-answer-' + i">Answer:</label>
                    <input class="form-check-input flex-shrink-0" type="checkbox" [attr.id]="'mcq-option-answer-' + i"
                      [(ngModel)]="option.answer" (click)="answerMarked()"
                      [ngModelOptions]="{ standalone: true }" [disabled]="useQuestionBank || question.disabled">
                  </div>
                  <div *ngIf="question.rankedMultipleChoice" class="d-flex align-items-center gap-1 flex-shrink-0">
                    <label class="form-label small mb-0 text-nowrap">Marks:</label>
                    <input class="form-control form-control-sm option-marks-input" type="number" min="0" [max]="question.marks"
                      [(ngModel)]="option.answerMarks" [ngModelOptions]="{ standalone: true }"
                      [disabled]="useQuestionBank || question.disabled">
                  </div>
                  <span class="cursorP ms-auto" *ngIf="!useQuestionBank && !question.disabled" (click)="removeOption(i)">x</span>
                </div>
                <div class="question-editor-wrapper">
                  <app-quill-editor *ngIf="exam && exam.id && optionAdvanceMode"
                    [readonly]="useQuestionBank || question.disabled" [placeholder]="'Type your text here...'"
                    [class.readonly-quill]="useQuestionBank || question.disabled" [(ngModel)]="option.optionHtml"
                    [ngModelOptions]="{ standalone: true }" [height]="'100px'"
                    [disabled]="question.disabled || useQuestionBank"></app-quill-editor>
                </div>
                <textarea class="form-control" rows="2  " [(ngModel)]="option.optionHtml"
                  [ngModelOptions]="{ standalone: true }" *ngIf="!optionAdvanceMode"
                  [readonly]="useQuestionBank || question.disabled"></textarea>

              </div>
            </div>
            <div class="d-flex flex-column align-items-end"
              *ngIf="question.questionType!='SAQ' && question.questionType!='Essay' && !useQuestionBank && !question.disabled">
              <button class="btn btn-secondary mt-1" (click)="pushOption()">+ Add New Option</button>
            </div>
          </ng-container>

          <ng-container *ngIf="exam.examinationType == 'Short Answer Question' || question.questionType =='SAQ'">
            <div class="mb-3 mr-0 col">
              <label class="form-label">SAQ Possible Answers (separator '|')</label>
              <input class="form-control" type="text" [(ngModel)]="question.saqPossibleAnsers"
                [ngModelOptions]="{ standalone: true }" [readonly]="useQuestionBank || question.disabled"
                [class.readonly-field]="useQuestionBank || question.disabled">
            </div>
          </ng-container>

          <ng-container *ngIf="exam.examinationType == 'Essay' || question.questionType == 'Essay'">
            <div class="d-flex flex-row justify-content-between align-items-center">
              <h5 class="form-label mt-4">Sub Questions</h5>
              <button *ngIf="!useQuestionBank && !question.disabled" class="btn btn-sm btn-secondary mt-4"
                (click)="pushEssaySubQuestion()">+ Add New Sub-Question</button>
            </div>

            <!-- Render essay Sub-Questions -->
            <div *ngFor="let subQuestion of question.essaySubQuestions; let i = index"
              class="row g-2 align-items-start mt-3">
              <div class="col-auto pt-2">
                <label>{{ (subQuestion.questionNoLabel || getLetter(i)) + '.' }}</label>
              </div>

              <div class="col">
                <app-quill-editor *ngIf="exam && exam.id" [(ngModel)]="subQuestion.questionHtml"
                  [ngModelOptions]="{ standalone: true }" [maxHeight]="'120px'" [placeholder]="'Type your text here...'"
                  class="w-100" [readonly]="useQuestionBank || question.disabled"></app-quill-editor>
              </div>

              <div class="col-md-2">
                <label class="form-label">Marks</label>
                <input class="form-control" type="number" min="0" [(ngModel)]="subQuestion.marks"
                  [ngModelOptions]="{ standalone: true }" [readonly]="useQuestionBank || question.disabled" />
              </div>
            </div>

            <!-- Remove last Sub-Question button -->
            <div class="text-end mt-3" *ngIf="question.essaySubQuestions?.length > 0">
              <button *ngIf="!useQuestionBank && !question.disabled" class="btn btn-sm btn-danger"
                (click)="removeEssaySubQuestion()">
                − Remove Last Sub-Question
              </button>
            </div>
          </ng-container>

          <div class="row">
            <div class="mb-3 mr-0 col">
              <label class="form-label">Marks</label>
              <input class="form-control" type="number" min="0" [(ngModel)]="question.marks"
                [ngModelOptions]="{ standalone: true }" [disabled]="question.disabled || useQuestionBank">
            </div>

            <div class="mb-3 mr-0 col">
              <label class="form-label">Penalty Marks</label>
              <input class="form-control" id="penaltyMarksInput" type="number" min="0" [(ngModel)]="question.penaltyMarks"
                [ngModelOptions]="{ standalone: true }" [disabled]="question.disabled || useQuestionBank">
            </div>

            <ng-container *ngIf="exam.useQuestionTimer">
              <div class="mb-3 mr-0 col">
                <div class="form-check mb-1">
                  <input class="form-check-input" type="checkbox" id="useCustomDuration"
                    [(ngModel)]="question.useCustomDuration" [ngModelOptions]="{ standalone: true }"
                    [disabled]="question.disabled" (ngModelChange)="onUseCustomDurationChange()">
                  <label class="form-check-label" for="useCustomDuration">
                    Use Custom Duration
                  </label>
                </div>
                <label class="form-label">
                  Duration (Seconds)
                </label>
                <input class="form-control" type="number" min="1" [ngModel]="(question.disabled || !question.useCustomDuration) 
                ? exam.defaultQuestionDuration 
                : question.duration" [ngModelOptions]="{ standalone: true }"
                  [disabled]="question.disabled || !question.useCustomDuration"
                  (ngModelChange)="question.useCustomDuration && !question.disabled && (question.duration = $event)" />
              </div>
            </ng-container>

            <div class="mt-4 form-check col">
              <input class="form-check-input" type="checkbox" [(ngModel)]="question.disabled"
                [ngModelOptions]="{ standalone: true }">
              <label class="form-check-label" for="flexCheckDefault">
                Disable Question
              </label>
            </div>
          </div>
          <div class="row">
            <div class="mb-3 mr-0 col" *ngIf="exam?.id">
              <app-category-select [readonly]="useQuestionBank || question.disabled"
                [(selectedCategory)]="question.category">
              </app-category-select>
            </div>
            <div class="mb-3 mr-0 col">
              <div class="dropdown">
                <label class="form-label">Language</label>
                <ng-select class="form-select form-control" id="language" name="language"
                  [(ngModel)]="question.language" [disabled]="question.disabled || useQuestionBank">
                  <ng-option value="" disabled>Select Language</ng-option>
                  <ng-option *ngFor="let lang of languages" [value]="lang.code" selected="">{{lang.lang}}</ng-option>
                </ng-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="mb-3 mr-0 col" *ngIf="exam.examinationType=='Essay'">
              <label class="form-label">Max. Word Count</label>
              <input [class.readonly-field]="useQuestionBank || question.disabled" class="form-control" type="number"
                min="0" [(ngModel)]="question.maxWordCount" [ngModelOptions]="{ standalone: true }"
                [readonly]="useQuestionBank || question.disabled">
            </div>
            <div class="mb-3 mr-0 col" *ngIf="!useQuestionBank">
              <label class="form-label">Question Group</label>
              <ng-select [readonly]="useQuestionBank || question.disabled" class="form-select"
                [(ngModel)]="question.questionGroupID" [class.readonly-field]="useQuestionBank || question.disabled"
                [ngModelOptions]="{ standalone: true }">
                <ng-option value="" disabled>Select Question Group</ng-option>
                <ng-option *ngFor="let qG of questionGroups" [value]="qG.questionGroupID">{{qG.name}}</ng-option>
              </ng-select>

            </div>
          </div>
          <div class="row align-items-center">
            <div class="mb-3 mr-0 col" *ngIf="!isSave && exam.examinationType=='Essay'">
              <label class="form-label">Question No.</label>
              <input class="form-control" type="number" min="0" [(ngModel)]="question.questionNumber"
                [ngModelOptions]="{ standalone: true }" [disabled]="question.disabled || useQuestionBank">
            </div>
            <div class="mb-3 mr-0 col">
              <input class="form-check-input" type="checkbox" [(ngModel)]="question.compulsory"
                [ngModelOptions]="{ standalone: true }" [disabled]="question.disabled">
              <label class="form-check-label ml-1">Set as Compulsory Question</label>
            </div>
          </div>

          <div class="row mt-3">
            <div class="mb-3 mr-0 col" *ngIf="!isSave">
              <input class="form-control bg-primary text-white" type="button" value="Update Question"
                (click)="saveQuestion(true)">
            </div>
            <div class="mb-3 mr-0 col" *ngIf="isSave">
              <input class="form-control bg-primary text-white" type="button" value="Save Question"
                (click)="saveQuestion()" [disabled]="useQuestionBank">
            </div>
            <div class="mb-3 mr-0 col">
              <input class="form-control bg-secondary text-white" type="button" value="Cancel" (click)="cancel()">
            </div>
          </div>
          <div class="row mt-3">
            <div class="mb-3 mr-0 col">
              <input class="form-control bg-success text-white" type="button" value="Create New Question"
                (click)="createNewQuestion()" [disabled]="useQuestionBank">
            </div>
          </div>
        </form>
      </div>


      <div class="splitter" (mousedown)="startDragging($event)"></div>

      <div class="right-panel">
        <h6 class="text-center">Question Preview</h6>

        <div class="border-0 rounded-lg w-100">

          <div class="row pb-0 paddedrow">
            <div class="col-lg-12 d-flex flex-column">
              <div class="icon-box justify-content-center mx-3 pl-2 mb-2 h3" data-aos="fade-up" data-aos-delay="100">
                <h6>Question: </h6>
                <section [innerHTML]="question.questionHtml" class="lead main pt-0"
                  style="font-size: 20px !important; color: #000; font-family: Poppins !important;" aria-live="polite"
                  tabindex="0">
                </section>
              </div>
            </div>
          </div>
          <div class="row pb-0 paddedrow questionborder">
          </div>
          <div class="row pb-3 paddedrow" style="width: 100%;" *ngIf="question.options && question.options.length > 0">
            <div class="col-lg-12 d-flex flex-column" *ngIf="!essayexam">
              <div class="section-title">
              </div>
              <div class="col-lg-12 d-flex flex-column">
                <div class="icon-box justify-content-center mx-3 pl-2 mb-2 h3" data-aos="fade-up" data-aos-delay="100">
                  <h6>Options:</h6>
                </div>
              </div>
              <div class="icon-box justify-content-center mx-3 pl-2 mb-2 h3" data-aos="fade-up" data-aos-delay="100">
                <!-- Radio group (single select; ranked MCQ is never shown as multiselect) -->
                <div class="col-md-12" *ngIf="!multiple || question.rankedMultipleChoice">
                  <fieldset>
                    <div class="custom-control custom-radio" *ngFor="let option of question.options">
                      <label class="radio radio-gradient">
                        <span class="radio__input">
                          <input type="radio" #optionInput [name]="option.optionID"
                            [attr.class]="question.questionID" [value]="option.optionID" id="{{option.optionID}}"
                            [attr.aria-labelledby]="'label-' + option.optionID" [disabled]="true"
                            [checked]="option.answer">
                          <span class="radio__control"></span>
                        </span>
                        <span tabindex="-1" aria-hidden="true" [innerHTML]="option.optionHtml" class="radio__label"
                          style=" font-size: 18px !important;"></span>
                      </label>
                    </div>
                  </fieldset>
                </div>

                <!-- Checkbox group (select all that apply — not used for ranked MCQ) -->
                <div class="col-md-12" *ngIf="multiple && !question.rankedMultipleChoice">
                  <fieldset>
                    <legend class="sr-only">
                      Select All That Apply
                    </legend>
                    <div class="custom-control custom-checkbox" *ngFor="let option of question.options">
                      <label class="checkbox" [attr.for]="option.optionID">
                        <span class="checkbox__input">
                          <input type="checkbox" [value]="option.optionID" id="{{option.optionID}}"
                            [attr.aria-labelledby]="'label-' + option.optionID" [disabled]="question.disabled" [checked]="option.answer">
                          <span class="checkbox__control">
                            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden="true"
                              focusable="false">
                              <path fill='none' stroke='currentColor' stroke-width='3'
                                d='M1.73 12.91l6.37 6.37L22.79 4.59' />
                            </svg>
                          </span>
                        </span>
                        <span tabindex="-1" aria-hidden="true" [innerHTML]="option.optionHtml" class="radio__label"
                          style=" font-size: 18px !important; padding-top: 5px;"></span>
                      </label>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>

            <!-- Essay Sub-Questions -->
            <ng-container *ngIf="essayexam && !issaq && question.essaySubQuestions.length>0">
              <div class="sr-only" aria-live="polite">
                {{ question.essaySubQuestions.length }} SubQuestions
              </div>
              <div *ngFor="let essaySubQuestion of question.essaySubQuestions; let i = index; let isLast = last">
                <!-- Display sub question HTML with question number -->
                <div class="col-lg-12 d-flex flex-column px-3">
                  <div class="flex-row mt-3" style="display: flex; align-items: flex-start; gap: 20px;" tabindex="0"
                    [attr.aria-label]="'Sub Question' + essaySubQuestion.questionNoLabel + '  question is' + ' ' + essaySubQuestion.questionHtml">
                    <div
                      style="font-size: 1.25rem !important; font-weight: 600; font-family: Poppins !important; flex-shrink: 0; color: #5c768d;">
                      {{essaySubQuestion.questionNoLabel}}.
                    </div>
                    <section class="lead main my-0 py-0"
                      style="font-size: 18px !important; color: #000; font-family: Poppins !important; flex: 1;"
                      [innerHTML]="essaySubQuestion.questionHtml">
                    </section>
                  </div>
                  <div class="text-center px-2 pb-1 paddedrow questionborder" style="width: 100%;"></div>
                </div>

              </div>
            </ng-container>

          </div>
        </div>



      </div>

    </div>
  </div>
</div>